import { getI18nLangOverride } from '../components/debug-panel/debugOverrides';
import { getI18nManualLang, setI18nManualLang } from '../utils/windowGlobals';

/**
 * Per-locale public-pricing HTML wrappers set `window.I18N_MANUAL_LANG`
 * before our bundle runs. Wrap the read so the cast lives in one place
 * and call sites stay type-safe.
 *
 * When a debug override is active in localStorage, that value wins.
 */
export function getManualI18nLang() {
  var _getI18nLangOverride;
  return (_getI18nLangOverride = getI18nLangOverride()) !== null && _getI18nLangOverride !== void 0 ? _getI18nLangOverride : getI18nManualLang();
}

/**
 * Call once at boot (before i18n setup) to sync the debug override into
 * the window global so `getPreferredLanguage` (which reads the global
 * directly) stays consistent for the rest of the session.
 */
export function applyI18nDebugOverride() {
  const override = getI18nLangOverride();
  if (override) {
    setI18nManualLang(override);
  }
}